import React, { useEffect } from 'react'
import Procedure from './Procedure'
import { motion } from 'framer-motion'
import { makeStyles } from '@mui/styles'
import { useNavigate, useLocation } from 'react-router-dom'
import Trips from './Trips'
import Header from './Header'
import { Box } from '@mui/material'
import { useAuth } from '../../contexts/AuthContext'

const useStyles = makeStyles(theme => ({
	root: {
		margin: 'auto',
		backgroundColor: '#fff',
		// border: '1px solid red'
	},
}))

const Main = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const {currentUser,logout} = useAuth() || {currentUser: null, logout: () => {}}
	// Function to get query parameters
	const getQueryParam = param => {
		const params = new URLSearchParams(location.search)
		return params.get(param)
	}

	const transactionId = getQueryParam('transactionId')

	// Redirect to /ticket if transactionId is present
	useEffect(() => {
		if (transactionId) {
			navigate(`/ticket?transactionId=${transactionId}`)
		}
	}, [transactionId, navigate])

	const classes = useStyles()
	const containerVariants = {
		hidden: {
			opacity: 0.5,
			scale: 1.2,
		},
		visible: {
			opacity: 1,
			scale: 1,
			transition: { delay: 0, duration: 0.5 },
		},
		exit: {
			x: '-100vw',
			transition: {
				duration: 0.8,
				ease: 'easeInOut',
			},
		},
	}
	return (
		<motion.main
			className={classes.root}
			variants={containerVariants}
			initial="hidden"
			animate="visible"
			exit="exit"
		>
			<Box sx={{padding:'16px'}}>
				<Header />
			</Box>

			{/* <Trips /> */}
			<Procedure />
			{/* <AppAd /> */}
		</motion.main>
	)
}

export default Main
